
import HttpClienteApiKey from '../../services/HttpClientApiKey';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';
import { AgregarServicioParams, AgregarServicioResponse, ImprimirTicketParams, ReenviarWhatsAppParams, ValidarTelefonoCelularWhatsAppParams } from '../../interfaces/comun/ServicioInterface';

export const AgregarServicio = ( params: AgregarServicioParams ) => {

    return new Promise<AgregarServicioResponse>( (resolve, eject) => {   

        HttpClienteApiKey.post('/Api/Servicio/AgregarServicio', params)
        .then( ({ data } : { data : AgregarServicioResponse } ) => {               
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve( {
                success: false,
                message: error.message,
                idServicio: 0,
                codigoAcceso: '',
                numeroTurno: '',
            } );
        });        

    });

}

export const ImprimirTicket = ( params: ImprimirTicketParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {   

        HttpClienteApiKey.post('/Api/Servicio/ImprimirTicket', params )
         .then( ({ data } : { data : HttpResponse } ) => {                 
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve( { success: false, message: error.message } );
        });        

    });

}

export const ValidarTelefonoCelularWhatsApp = ( params: ValidarTelefonoCelularWhatsAppParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {   

        HttpClienteApiKey.post('/Api/Servicio/ValidarTelefonoCelularWhatsApp', params )
         .then( ({ data } : { data : HttpResponse } ) => {                 
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve( { success: false, message: error.message } );
        });        

    });

}

export const ReenviarWhatsApp = ( params: ReenviarWhatsAppParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {   

        HttpClienteApiKey.post('/Api/Servicio/ReenviarWhatsApp', params )
         .then( ({ data } : { data : HttpResponse } ) => {                 
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve( { success: false, message: error.message } );
        });        

    });

}
